import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

/**
 * API para el módulo de rastreo de trabajadores
 */
class TrackingAPI {
  /**
   * Obtener ubicaciones actuales de todos los trabajadores
   *
   * @returns {Promise<Array>} - Array de ubicaciones actuales
   */
  async getCurrentWorkerLocations() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      console.log('📡 Llamando a API:', `${API_BASE_URL}/api/v1/tracking/workers/current`);

      const response = await axios.get(
        `${API_BASE_URL}/api/v1/tracking/workers/current`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log('✅ Respuesta del API:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo ubicaciones actuales:', error);
      console.error('❌ Error response:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      throw error;
    }
  }

  /**
   * Obtener historial de ubicaciones de un trabajador
   *
   * @param {number} id_trabajador - ID del trabajador
   * @param {string} fecha_inicio - Fecha inicio (ISO 8601)
   * @param {string} fecha_fin - Fecha fin (ISO 8601)
   * @param {number} limit - Límite de resultados (opcional)
   * @returns {Promise<Object>} - Historial de ubicaciones
   */
  async getWorkerLocationHistory(id_trabajador, fecha_inicio, fecha_fin, limit = 100) {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${API_BASE_URL}/api/v1/tracking/workers/${id_trabajador}/history`,
        {
          params: {
            fecha_inicio,
            fecha_fin,
            limit
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo historial de ubicaciones:', error);
      throw error;
    }
  }

  /**
   * Obtener ruta (polyline) de un trabajador
   *
   * @param {number} id_trabajador - ID del trabajador
   * @param {string} fecha_inicio - Fecha inicio (ISO 8601)
   * @param {string} fecha_fin - Fecha fin (ISO 8601)
   * @returns {Promise<Object>} - Ruta del trabajador
   */
  async getWorkerRoute(id_trabajador, fecha_inicio, fecha_fin) {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${API_BASE_URL}/api/v1/tracking/workers/${id_trabajador}/route`,
        {
          params: {
            fecha_inicio,
            fecha_fin
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo ruta del trabajador:', error);
      throw error;
    }
  }

  /**
   * Obtener estadísticas de tracking de un trabajador
   *
   * @param {number} id_trabajador - ID del trabajador
   * @param {string} fecha_inicio - Fecha inicio (ISO 8601)
   * @param {string} fecha_fin - Fecha fin (ISO 8601)
   * @returns {Promise<Object>} - Estadísticas del trabajador
   */
  async getWorkerStats(id_trabajador, fecha_inicio, fecha_fin) {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${API_BASE_URL}/api/v1/tracking/workers/${id_trabajador}/stats`,
        {
          params: {
            fecha_inicio,
            fecha_fin
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo estadísticas del trabajador:', error);
      throw error;
    }
  }
}

export default new TrackingAPI();
